<template>
  <v-container class="fill-height">
    <v-row class="mb-5" style="margin-bottom:0px !important;">
      <v-col cols="12" md="2" lg="2" sm="6">
        <v-combobox
          v-model="searchPeriod"
          item-text="title"
          item-value="value"
          :items="periods"
          hide-details
          @change="searchPeriodChanged"
        ></v-combobox>
      </v-col>
      <v-col cols="12" md="2" lg="2" sm="6">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :return-value.sync="startDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="startDate" label="From" readonly v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="startDate" no-title scrollable type="month">
            <v-btn text color="secondary" @click="menu1 = false">Cancel</v-btn>
            <v-btn text color="secondary" @click="$refs.menu1.save(startDate)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="2" lg="2" sm="6">
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :return-value.sync="endDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="endDate" label="To" readonly v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="endDate" no-title scrollable type="month">
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="menu2 = false">Cancel</v-btn>
            <v-btn text color="secondary" @click="$refs.menu2.save(endDate)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="2" lg="2" sm="6">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter campaign"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col align="right">
        <v-btn class="ma-2" @click="fetchReports" small outlined color="secondary">Search</v-btn>
        <v-btn class="ma-2" @click="fetchReports" small outlined fab color="secondary">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!--  -->
    <v-row>
      <v-col cols="12" class="ma-0 pa-0">
        <!-- <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field> -->
        <v-data-table :headers="headers" :search="search" :items="stats" class="elevation-1">
          <template v-slot:body="{ items }">
            <tbody>
              <!-- Summary -->
              <tr class="tr-summary">
                <td class="caption text-xs-center" v-for="(header, index) in headers" :key="index" align="center">
                  <p class="caption ma-0" v-if="header.value === 'campaignName'" align="left">
                    <b>Summary</b>
                  </p>
                  <p class="caption ma-0" v-if="header.value === 'engagement'" >
                    <v-chip class="ma-1" color="primary" small text-color="white">
                      <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                      <span>{{(summary[header.month] ? summary[header.month].engagement : 0) | thousandSeprator}}</span>
                    </v-chip>
                  </p>
                  <p class="caption ma-0" v-if="header.value === 'contents'">                    
                    <v-chip class="ma-1" color="primary" small text-color="white">
                      <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                      <span >{{(summary[header.month] ? summary[header.month].contents : 0) | thousandSeprator}}</span>
                    </v-chip>
                  </p>
                  <p class="caption ma-0" v-if="header.value === 'outreach'">
                    <v-chip class="ma-1" color="primary" small text-color="white">
                      <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                      {{(summary[header.month] ? summary[header.month].outreach : 0) | thousandSeprator}}
                    </v-chip>
                  </p>
                  <p class="caption ma-0" v-if="header.value === 'revenue'">
                    <v-chip class="ma-1" color="primary" small text-color="white">
                      <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                      <!-- <span>{{(summary[header.month] ? summary[header.month].revenue : 0) | thousandSeprator}}</span>                       -->              
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                          ><span>{{(summary[header.month] ? (summary[header.month].revenueCalculation === 'content' ? summary[header.month].revenueByContents : summary[header.month].revenue) | thousandSeprator : 0) | thousandSeprator}}</span></span>
                        </template>
                        <span>{{(summary[header.month] ? (summary[header.month].revenueCalculation === 'content' ? 'Revenue by contents' : 'Revenue by engagement') : 'N/A')}}</span>
                      </v-tooltip>
                    </v-chip>
                  </p>
                </td>
              </tr>
              <!-- Monthly view -->
              <tr v-for="(item, index) in items" :key="index">               
                <td class="caption" v-for="(header, index) in headers" :key="index" align="center">
                  <p class="caption ma-0" align="left"
                    v-if="header.value === 'campaignName'"
                  >{{ item.campaignName }}</p>
                  <p
                    class="caption ma-0"
                    v-if="header.value === 'engagement'"
                  >
                  <span>{{(item[header.month] ? item[header.month].engagement : 0) | thousandSeprator}}</span>                  
                  </p>
                  <p
                    class="caption ma-0"
                    v-if="header.value === 'contents'"
                  >    
                  <span>{{(item[header.month] ? item[header.month].contents : 0) | thousandSeprator}}</span>
                  </p>
                  <p
                    class="caption ma-0"
                    v-if="header.value === 'outreach'"
                  >{{(item[header.month] ? item[header.month].outreach : 0) | thousandSeprator}}</p>
                  <p class="caption ma-0" v-if="header.value === 'revenue'">
                    <v-chip class="ma-1" color="green" small text-color="white">
                      <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                      <!-- <span>{{(item[header.month] ? item[header.month].revenueByContents : 0) | thousandSeprator}}</span>             -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                          >
                            <span>{{(item[header.month] ? (item[header.month].revenueCalculation === 'content' ? item[header.month].revenueByContents : item[header.month].revenue) | thousandSeprator : 0) | thousandSeprator}}</span>
                          </span>
                        </template>
                        <span>{{(item[header.month] ? (item[header.month].revenueCalculation === 'content' ? 'Revenue by contents' : 'Revenue by engagement') : 'N/A')}}</span>
                      </v-tooltip>
                    </v-chip>
                  </p>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-container>
</template>
<script>
const TIME_PERIOD = {
  THIS_MONTH: 'THIS_MONTH',
  THIS_YEAR: 'THIS_YEAR',
  THIS_QUARTER: 'THIS_QUARTER',
  LAST_QUARTER: 'LAST_QUARTER',
  CUSTOM: 'CUSTOM'
};
import moment from 'moment';
import utils from '@/utils';
import campaignAPIs from './campaignAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {
    Loading
  },
  data(vm) {
    return {
      isLoading: false,
      MONTH_FORMAT: 'YYYY-MM',
      search: null,
      searchPeriod: { title: 'This Quarter', value: 'THIS_QUARTER' },
      periods: [
        {
          title: 'This Month',
          value: TIME_PERIOD.THIS_MONTH
        },
        {
          title: 'This Year',
          value: TIME_PERIOD.THIS_YEAR
        },
        {
          title: 'This Quarter',
          value: TIME_PERIOD.THIS_QUARTER
        },
        {
          title: 'Custom',
          value: TIME_PERIOD.CUSTOM
        }
      ],
      summary: {},
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
      menu1Date: null,
      menu2Date: null,
      headers: [],
      campaigns: [],
      months: [],
      stats: [],
      // Visibility settings
      viewEngagement: true,
      viewRevenue: true,
      viewOutreach: true,
      revenueOpt: 'eng'
    };
  },
  async mounted() {
    this.generateQuarter();
    await this.fetchReports();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    searchPeriodChanged(data) {
      const value = data.value;
      switch (value) {
        case TIME_PERIOD.THIS_MONTH:
          this.startDate = moment().format(this.MONTH_FORMAT);
          this.endDate = moment().format(this.MONTH_FORMAT);
          break;
        case TIME_PERIOD.THIS_YEAR:
          this.startDate = moment()
            .startOf('year')
            .format(this.MONTH_FORMAT);
          this.endDate = moment()
            .endOf('year')
            .format(this.MONTH_FORMAT);
          break;
        case TIME_PERIOD.THIS_QUARTER:
          const quarter = moment().quarter();
          this.generateQuarter(quarter);
          break;
      }
    },
    async fetchReports() {
      try {
        this.isLoading = true;
        const fromOriginal = moment(this.startDate, this.MONTH_FORMAT);
        const toOriginal = moment(this.endDate, this.MONTH_FORMAT);
        const from = fromOriginal.format('MM-YYYY');
        const to = toOriginal.format('MM-YYYY');
        const reports = await campaignAPIs.getMonthlyCampaignsReport({ from, to });
        const campaigns = reports.map(rp => {
          return {
            id: rp.id,
            clientID: rp.clientID,
            name: rp.name,
            outreach: rp.outreach,
            engagement: rp.engagement,
            budget: rp.budget
          };
        });
        this.campaigns = campaigns;
        this.generateStats(reports);
        this.generateHeaders(fromOriginal, toOriginal);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    generateHeaders(from, to) {
      const headers = [{ text: 'Campaign', value: 'campaignName' }];
      const months = [];
      for (let date = from; date.isSameOrBefore(to); date.add(1, 'month')) {
        headers.push({
          align: 'center',
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Engagement)',
          sortable: false,
          value: 'engagement'
        });
        headers.push({
          align: 'center',
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Contents)',
          sortable: false,
          value: 'contents'
        });
        headers.push({
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Outreach)',
          sortable: false,
          value: 'outreach'
        });
        headers.push({
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Revenue)',
          sortable: false,
          value: 'revenue'
        });
        months.push(date.format('MM-YYYY'));
      }
      this.headers = headers;
      this.months = months;
    },
    generateQuarter() {
      const thisQuarter = moment().quarter();
      const dateRage = utils.func.getQuarterRange(thisQuarter);
      const from = dateRage.from;
      const to = dateRage.to;
      this.startDate = from.format(this.MONTH_FORMAT);
      this.endDate = to.format(this.MONTH_FORMAT);
    },
    async generateStats(reports) {
      const stats = new Map();
      const summary = new Map();
      for (let report of reports) {
        const data = stats.get(report.campaignId) || {};
        if (!stats.has(report.campaignId)) {
          data['campaignName'] = report.campaignName;
          data['campaignId'] = report.campaignId;
        }
        data[report.datetime] = report;
        let monthlySummary = summary.get(report.datetime);
        if (monthlySummary) {
          monthlySummary['revenue'] += report.revenue;
          monthlySummary['engagement'] += report.engagement;
          monthlySummary['revenueByContents'] += report.revenueByContents;
          monthlySummary['contents'] += report.contents;
          monthlySummary['outreach'] += report.outreach;
          monthlySummary['revenueCalculation'] = report.revenueCalculation;
        } else {
          monthlySummary = {
            revenue: report.revenue,
            engagement: report.engagement,
            revenueByContents: report.revenueByContents,
            contents: report.contents,
            outreach: report.outreach,
            revenueCalculation: report.revenueCalculation
          };
        }
        summary.set(report.datetime, monthlySummary);
        stats.set(report.campaignId, data);
      }
      this.stats = [];
      this.summary = {};
      for (let value of stats.values()) {
        this.stats.push(value);
      }
      for (let [key, value] of summary.entries()) {
        value.revenue = Number(value.revenue).toFixed(2);
        this.summary[key] = value;
      }
    },
    radioOnChangeHandler () {
      const fromOriginal = moment(this.startDate, this.MONTH_FORMAT);
      const toOriginal = moment(this.endDate, this.MONTH_FORMAT);
      this.generateHeaders(fromOriginal, toOriginal);
    }
  }
};
</script>
<style scoped>
table thead th {
  font-size: 0.5rem !important;
}
table tbody td {
  font-size: 6px !important;
}
.v-text-field {
  width: 400px;
}
.tr-summary {
  background-color: #d2d6de;
}
.tr-summary:hover {
  background-color: #d2d6de !important;
}
</style>



// WEBPACK FOOTER //
// CampaignsOverview.vue?680127b6